import { render, staticRenderFns } from "./InstagramIcon.vue?vue&type=template&id=57275c37&scoped=true"
import script from "./InstagramIcon.vue?vue&type=script&lang=ts"
export * from "./InstagramIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57275c37",
  null
  
)

export default component.exports